import { RouteRecordRaw } from 'vue-router';

export default (): Array<RouteRecordRaw> => {
    return [
        {
            path: '/network/home',
            name: 'network_home',
            component: () => import("./views/home.vue"),
            meta: {
                hasBar: true,
                bottomCutFixed: true
            }
        },
        {
            path: '/network/deferredPaymentPending',
            name: 'network_deferredPaymentPending',
            component: () => import("./views/deferredPaymentPending.vue"),
            meta: {
                hasBar: false,
                bottomCutFixed: true
            }
        },
        {
            path: '/network/requestPayment',
            name: 'network_requestPayment',
            component: () => import("./views/requestPayment.vue"),
            meta: {
            }
        },
        {
            path: '/network/transferCoins',
            name: 'network_transferCoins',
            component: () => import("./views/transferCoins.vue"),
            meta: {
            }
        },
        {
            path: '/network/walletTransactions',
            name: 'network_walletTransactions',
            component: () => import("./views/walletTransactions.vue"),
            meta: {
            }
        },
        {
            path: '/network/waitingCommissions',
            name: 'network_waitingCommissions',
            component: () => import("./views/waitingCommissions.vue"),
            meta: {
            }
        },
    ];
};